var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetterCoverIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 45.3097C35.9264 45.3097 46 35.1668 46 22.6549C46 10.1429 35.9264 0 23.5 0C11.0736 0 1 10.1429 1 22.6549C1 35.1668 11.0736 45.3097 23.5 45.3097Z",
    fill: "#EEEDF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3406 45.3096H45.9999",
    stroke: "#1E247E",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.903 45.3096H42.6291",
    stroke: "#1E247E",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 45.3096H3.18112",
    stroke: "#1E247E",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0335 21.9507C38.0508 21.9507 39.6861 20.3041 39.6861 18.273C39.6861 16.2418 38.0508 14.5952 36.0335 14.5952C34.0162 14.5952 32.3809 16.2418 32.3809 18.273C32.3809 20.3041 34.0162 21.9507 36.0335 21.9507Z",
    fill: "#D3D5E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3105 26.4899V42.5248C39.3105 44.0064 38.1208 45.2043 36.6493 45.2043H10.3506C8.87917 45.2043 7.68947 44.0064 7.68947 42.5248V26.4899C7.68947 26.2061 7.74165 25.9224 7.85644 25.6597C7.97124 25.376 8.13822 25.1133 8.36781 24.9032L21.1519 12.6195C22.4668 11.3586 24.5332 11.3586 25.8585 12.6195L38.6426 24.9032C38.8722 25.1238 39.0392 25.376 39.154 25.6597C39.2479 25.9224 39.3105 26.2061 39.3105 26.4899Z",
    fill: "#DBE7FE",
    stroke: "#1E247E",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1436 25.6704L34.5935 28.7597L27.3405 33.6774C25.0237 35.2535 21.9868 35.2535 19.6596 33.6774L12.4066 28.7597L7.85648 25.6704",
    stroke: "#1E247E",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3654 39.6978L19.2003 40.3492",
    stroke: "#1E247E",
    strokeWidth: 0.292969,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3655 38.8892L20.0457 40.1816",
    stroke: "#1E247E",
    strokeWidth: 0.292969,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5761 39.0044L20.0457 39.3617",
    stroke: "#1E247E",
    strokeWidth: 0.292969,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8181 32.416V34.7803",
    stroke: "#1E247E",
    strokeWidth: 0.351562,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8181 30.4722V31.0921",
    stroke: "#1E247E",
    strokeWidth: 0.351562,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2563 42.8608C38.1624 43.3337 37.8285 43.7225 37.3902 43.8906",
    stroke: "#1E247E",
    strokeWidth: 0.351562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1094 41.1383H11.1229C10.8098 41.1383 10.5593 40.8862 10.5593 40.5709V38.648C10.5593 38.3328 10.8098 38.0806 11.1229 38.0806H15.1094C15.4225 38.0806 15.673 38.3328 15.673 38.648V40.5709C15.673 40.8862 15.4225 41.1383 15.1094 41.1383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0677 36.8088H11.0811C10.7681 36.8088 10.5176 36.5566 10.5176 36.2413V34.3184C10.5176 34.0032 10.7681 33.751 11.0811 33.751H15.0677C15.3808 33.751 15.6312 34.0032 15.6312 34.3184V36.2413C15.6208 36.5566 15.3703 36.8088 15.0677 36.8088Z",
    fill: "white"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5935 24.2098V28.7597L26.1925 34.4549C24.5645 35.5582 22.446 35.5582 20.818 34.4549L12.417 28.7597V24.2098C12.417 24.0101 12.5735 23.8525 12.7718 23.8525H34.2387C34.4265 23.842 34.5935 24.0101 34.5935 24.2098Z",
    fill: "white",
    stroke: "#1E247E",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9585 30.4727H29.0415",
    stroke: "#1E247E",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9585 28.9277H29.0415",
    stroke: "#1E247E",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9585 27.373H29.0415",
    stroke: "#1E247E",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6025 13.8488C23.1035 13.3655 23.8966 13.3655 24.3975 13.8488",
    stroke: "#1E247E",
    strokeWidth: 0.351562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5935 21.0264C36.6108 21.0264 38.2461 19.3798 38.2461 17.3486C38.2461 15.3175 36.6108 13.6709 34.5935 13.6709C32.5762 13.6709 30.9409 15.3175 30.9409 17.3486C30.9409 19.3798 32.5762 21.0264 34.5935 21.0264Z",
    fill: "#DA867D",
    stroke: "#1E247E",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3664 13.5762L40.4898 14.1121",
    stroke: "white",
    strokeWidth: 0.820312,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9299 15.0474L41.022 15.0682",
    stroke: "white",
    strokeWidth: 0.820312,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7905 13.2608L40.1871 12.3677",
    stroke: "white",
    strokeWidth: 0.820312,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4312 12.8828C33.4484 12.8828 35.0838 11.2362 35.0838 9.20508C35.0838 7.17392 33.4484 5.52734 31.4312 5.52734C29.4139 5.52734 27.7786 7.17392 27.7786 9.20508C27.7786 11.2362 29.4139 12.8828 31.4312 12.8828Z",
    fill: "#D3D5E7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9388 11.7481C31.956 11.7481 33.5914 10.1015 33.5914 8.07032C33.5914 6.03916 31.956 4.39258 29.9388 4.39258C27.9215 4.39258 26.2862 6.03916 26.2862 8.07032C26.2862 10.1015 27.9215 11.7481 29.9388 11.7481Z",
    fill: "#79CAA1",
    stroke: "#1E247E",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9997 1.72363L28.8223 2.6168",
    stroke: "white",
    strokeWidth: 0.820312,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4446 1.98633L27.789 2.96356",
    stroke: "white",
    strokeWidth: 0.820312,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8288 3.47832L26.0357 2.90039",
    stroke: "white",
    strokeWidth: 0.820312,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M21.611 10.5186C23.6283 10.5186 25.2636 8.87198 25.2636 6.84082C25.2636 4.80967 23.6283 3.16309 21.611 3.16309C19.5937 3.16309 17.9584 4.80967 17.9584 6.84082C17.9584 8.87198 19.5937 10.5186 21.611 10.5186Z",
    fill: "#D3D5E7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8473 9.76173C21.8645 9.76173 23.4999 8.11515 23.4999 6.08399C23.4999 4.05283 21.8645 2.40625 19.8473 2.40625C17.83 2.40625 16.1947 4.05283 16.1947 6.08399C16.1947 8.11515 17.83 9.76173 19.8473 9.76173Z",
    fill: "#F0C330",
    stroke: "#1E247E",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7963 8.87842L14.2015 9.656",
    stroke: "white",
    strokeWidth: 0.820312,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3352 8.21734L14.3058 7.8916",
    stroke: "white",
    strokeWidth: 0.820312,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1161 6.64062L14.0031 6.84027",
    stroke: "white",
    strokeWidth: 0.820312,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1342 16.5814C34.1342 16.5814 34.8125 16.1191 35.0734 16.718C35.3656 17.3905 33.9985 18.2942 33.9985 18.2942H35.1882",
    stroke: "white",
    strokeWidth: 0.351562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6799 8.37477H28.9058L30.1686 6.78809V9.00524",
    stroke: "white",
    strokeWidth: 0.351562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9918 5.47475L19.6805 4.80225V7.02991",
    stroke: "white",
    strokeWidth: 0.351562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterCoverIcon);
export default __webpack_public_path__ + "static/media/Letter-cover-icon.da4e01eea0640bdba1d230ff9d8c3d5d.svg";
export { ForwardRef as ReactComponent };